/* unplugin-vue-components disabled */import script from "./subject-stage.vue?vue&type=script&setup=true&lang=js"
export * from "./subject-stage.vue?vue&type=script&setup=true&lang=js"

import "./subject-stage.vue?vue&type=style&index=0&id=31f8ef72&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31f8ef72"]])

export default __exports__